export function isModel(type) {
  var array = ["stl", "obj", "three", "collada", "ply", "gltf"];
  return array.includes(type);
}

export function mapFileToName(filename) {
  var name = "";
  var arr = filename.split('.').reverse().splice(1).reverse();
  arr.forEach((item, index) => {
    name += item;
    if(index !== arr.length - 1) {
        name += '.';
    }
  });
  return name;
}
export function iconType(type) {
  if(type == "video") {
    return 'movie';
  } else if(type == "img") {
    return "photo";
  } else if(type == "pdf") {
    return "insert_drive_file";
  } else if(type == "youtube") {
    return 'subscriptions';
  } else if(type == "wysiwyg") {
    return "text_format";
  } else if(type == "mp4link") {
    return "on_demand_video";
  } else if(isModel(type)) {
    return 'layers';
  }
}